import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Avis } from '../../../models/avis';
import { Endpoints } from '../../../models/endpoints';
import { FormsEnum } from '../../../models/enums/forms.enum';
import { HttpService } from '../../shared/services/http.service';
import { Historique } from '../visualiser-avis-de-pub/synthese/model/historique';
import { Synthesis } from '../visualiser-avis-de-pub/synthese/model/synthesis';
import { map } from 'rxjs/operators';
import { MotifChange } from '../../../models/motif-change';
import { AvisRevision } from '../../../models/avisRevision';

interface h {
  avis: {
    type: String,
    reference: String,
    status: String,
    historique: Historique
  }[],
  flux: {
    type: String,
    reference: String,
    status: String,
    dateCreation: String,
    dateEmission: String,
    dateReception: String
  }[]
}

@Injectable({
  providedIn: 'root',
})
export class AvisService {
  private _synthesis: BehaviorSubject<Synthesis> = new BehaviorSubject(new Synthesis());
  public synthesis$: Observable<Synthesis> = this._synthesis.asObservable();

  private _shouldUpdateSynthesis: Subject<boolean> = new Subject();
  public shouldUpdateSynthesis$: Observable<boolean> = this._shouldUpdateSynthesis.asObservable();

  constructor(private http: HttpService) {
  }

  public getSynthese(referenceAvis: string) {
    return this.http.get(Endpoints.AVIS_FIND_SYNTHESE_BY_REFERENCE + referenceAvis, Synthesis);
  }

  public getHistorique(referenceAvis: string) {
    return this.http.get(Endpoints.AVIS_FIND_HISTORIQUE_BY_REFERENCE + referenceAvis, Array);
  }

  public getAvisByReference(reference: string): Observable<Avis> {
    return this.http.get(Endpoints.AVIS_FIND_BY_REFERENCE + reference, Avis);
  }

  public getAvisByReferenceAvisLie(reference: string): Observable<Avis> {
    return this.http.get(Endpoints.AVIS_FIND_BY_REFERENCE_LIE + reference, Avis);
  }

  public getAvisByReferenceAvisConnexe(reference: string): Observable<Avis> {
    return this.http.get(Endpoints.AVIS_FIND_BY_REFERENCE_CONNEXE + reference, Avis);
  }

  public generatePdf(reference: string, langue: string): Observable<Blob> {
    return this.http.getBlob(Endpoints.AVIS_PDF + reference + Endpoints.PARAM_LANG + langue);
  }

  public updateSynthese(synthesis: Synthesis): Observable<Synthesis> {
    return this.http.post(Endpoints.AVIS_UPDATE_STATUS, synthesis, Synthesis);
  }

  public duplicate(referenceAvis: string): Observable<Avis> {
    return this.http.get(Endpoints.AVIS_DUPLICATE + referenceAvis, Avis);
  }

  public corrigerAvis(referenceAvis: string): Observable<Avis> {
    return this.http.get(Endpoints.AVIS_CORRIGER + referenceAvis, Avis);
  }

  public change(referenceAvis: string, motif: string): Observable<Avis> {
    const motifChange = new MotifChange
    motifChange.motif = motif;
    return this.http.post(Endpoints.AVIS_CHANGE + referenceAvis, motifChange, Avis);
  }

  public delete(referenceAvis: string): Observable<boolean> {
    return this.http.delete(Endpoints.AVIS_DELETE + referenceAvis, Boolean).pipe(map(r => r.valueOf()));
  }

  public getHistoRefConsultAvis(avisId: string): Observable<AvisRevision[]> {
    return this.http.get(Endpoints.HISTO_REF_CONSULT_AVIS + avisId, Array) as Observable<AvisRevision[]>;
  }

  public set shouldUpdateSynthesis(value) {
    this._shouldUpdateSynthesis.next(value);
  }

  public set synthesis(synthesis) {
    this._synthesis.next(synthesis);
  }

  /***
     * @auauthor kacimi hamza
     * @see refont tableau de bord / ajout filtre statut
     */
  public filterWithStatus(status:string,siret:string,service:string,page:number,
	pageSize:number,sortColumn:string,sortOrder:string,statutFilterEnable:boolean
  ) : Observable<Avis[]>{
	if(statutFilterEnable)
	return this.http
	    .get(Endpoints.AVIS_FIND_ALL+"?siret="+siret+"&service="+service+"&page="+
		page+"&pageSize="+pageSize+"&status="+status+"&sortColumn="+sortColumn+"&sortOrder="+sortOrder);
	else
	return this.http.get(
		      Endpoints.AVIS_FIND_ALL +
		      Endpoints.ADMIN_SIRET +
		      siret +
		      Endpoints.ADMIN_SERVICE +
		      service +
		      Endpoints.AVIS_LIES +
		      true + "&page="+
			  		page+"&pageSize="+pageSize
		    );

  }
}
